import dayjs from "dayjs";

export const skuValidation = (dataArr, data) => {
  const isValid = dataArr.some((x, i) => {
    if (x.lineNo !== data.lineNo) {
      const mln = x.mln === null ? "" : x.mln.trim();
      const mln_data = data.mln === null ? "" : data.mln.trim();
      //console.log(`${i}`,x.skuCode===data.skuCode && mln===mln_data && x.expiryDate===data.expiryDate)
      return x.skuCode === data.skuCode && mln === mln_data && x.expiryDate === data.expiryDate;
    }
  });
  //console.log(isValid)
  return isValid;
};

export const dateValidation = (dataArr, data) => {
  const isValid = dataArr.some((x) => {
    if (x.eta !== null) {
      const eta = dayjs(x.eta);
      const poDate = dayjs(data.poDate);
      return !eta.isSame(poDate) && eta.isBefore(poDate);
    }
  });
  //console.log(isValid)
  return isValid;
};

export const numberValidation=value=>{
  let temp = Number(value)
  if(Number.isNaN(temp)) temp=0
  return Math.abs(parseInt(temp))
}

export const qtyExpectedValidation = (data) => {
  console.log(data);
  // console.log(dataArr)
  //  const isValid = data.some(x => {
  // if(x.lineNo !== data.lineNo){
  return data.qtyExpected > data.defaultQtyExpected;
  // }
  // })
  // console.log(isValid)
  //  return isValid;
};

export const validateCustomerCarrier = (dataArr, data) => {
  const isValid = dataArr.some((x, i) => {
    if (x.no !== data.no) {
      // const mln = x.mln===null?"":x.mln.trim()
      // const mln_data=data.mln===null?"":data.mln.trim()
      //console.log(`${i}`,x.skuCode===data.skuCode && mln===mln_data && x.expiryDate===data.expiryDate)
      return x.shippingZone === data.shippingZone;
    }
  });
  //console.log(isValid)
  return isValid;
};

export const retailBarcodeValidation = (dataArr, data) => {
  const isValid = dataArr.some((x, i) => {
    if (x.no !== data.no) {
      return x.retailBarcode === data.retailBarcode;
    }
  });
  //console.log(isValid)
  return isValid;
};
